export default __webpack_public_path__ + "static/media/recruit-outline-16px.d9453e9f.svg";